module.exports = __webpack_public_path__ + "static/media/gngf.1d54e98d.gif";